import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="container">
        <NavLink to="/" className="logo-container">
          {/* استبدل التصميم النصي باللوجو الحقيقي */}
          <img 
            src= "/images/taqnya.ico" 
            alt="TAQNYA Logo" 
            className="logo-img"
            onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = 'none';
              // عرض بديل في حالة عدم وجود الصورة
              const logoDiv = document.createElement('div');
              logoDiv.className = 'logo-fallback';
              logoDiv.innerHTML = 'TAQNYA';
              e.target.parentNode.insertBefore(logoDiv, e.target);
            }}
          />
          <div className="logo-text">
            <h1>TAQNYA</h1>
            <p className="tagline">Smart Solutions</p>
          </div>
        </NavLink>
        
        <button 
          className="mobile-menu-btn" 
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          ☰
        </button>
        
        <nav className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          <ul>
            <li><NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink></li>
            <li><NavLink to="/about" onClick={() => setMenuOpen(false)}>About</NavLink></li>
            <li><NavLink to="/activity" onClick={() => setMenuOpen(false)}>Activity</NavLink></li>
            <li><NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact Us</NavLink></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;